// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contract-cards[data-v-4b2f49cb]{max-width:800px}", ""]);
// Exports
module.exports = exports;
